// Package Imports
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.css']
})
export class ErrorMessageComponent {
  @Input() control: FormControl;
  @Input() resources: any;
  @Input() fieldName: string;

  constructor() { }

  errorMessage(errorName: string): string {
    if (this.resources[errorName]) {
      const validationMessage = this.resources[errorName].replace('{Name}', this.fieldName);

      return validationMessage;
    }
    else {
      return 'Invalid input';
    }
  }

  get controlErrors(): string[] {
    return Object.keys(this.control.errors);
  }
}
